module.exports = function (SegmentShape, Utils, Konva) {
    'use strict';
    function SegmentsLayer(peaks, view, allowEditing) {
        this._peaks = peaks;
        this._view = view;
        this._allowEditing = allowEditing;
        this._segmentShapes = {};
        this._layer = new Konva.Layer();
        this._onSegmentsUpdate = this._onSegmentsUpdate.bind(this);
        this._onSegmentsAdd = this._onSegmentsAdd.bind(this);
        this._onSegmentsRemove = this._onSegmentsRemove.bind(this);
        this._onSegmentsRemoveAll = this._onSegmentsRemoveAll.bind(this);
        this._onSegmentsDragged = this._onSegmentsDragged.bind(this);
        this._peaks.on('segments.update', this._onSegmentsUpdate);
        this._peaks.on('segments.add', this._onSegmentsAdd);
        this._peaks.on('segments.remove', this._onSegmentsRemove);
        this._peaks.on('segments.remove_all', this._onSegmentsRemoveAll);
        this._peaks.on('segments.dragged', this._onSegmentsDragged);
    }
    SegmentsLayer.prototype.addToStage = function (stage) {
        stage.add(this._layer);
    };
    SegmentsLayer.prototype.enableEditing = function (enable) {
        this._allowEditing = enable;
    };
    SegmentsLayer.prototype.isEditingEnabled = function () {
        return this._allowEditing;
    };
    SegmentsLayer.prototype.formatTime = function (time) {
        return this._view.formatTime(time);
    };
    SegmentsLayer.prototype._onSegmentsUpdate = function (segment) {
        var redraw = false;
        var segmentShape = this._segmentShapes[segment.id];
        var frameOffset = this._view.getFrameOffset();
        var width = this._view.getWidth();
        var frameStartTime = this._view.pixelsToTime(frameOffset);
        var frameEndTime = this._view.pixelsToTime(frameOffset + width);
        if (segmentShape) {
            this._removeSegment(segment);
            redraw = true;
        }
        if (segment.isVisible(frameStartTime, frameEndTime)) {
            this._addSegmentShape(segment);
            redraw = true;
        }
        if (redraw) {
            this.updateSegments(frameStartTime, frameEndTime);
        }
    };
    SegmentsLayer.prototype._onSegmentsAdd = function (segments) {
        var self = this;
        var frameOffset = self._view.getFrameOffset();
        var width = self._view.getWidth();
        var frameStartTime = self._view.pixelsToTime(frameOffset);
        var frameEndTime = self._view.pixelsToTime(frameOffset + width);
        segments.forEach(function (segment) {
            if (segment.isVisible(frameStartTime, frameEndTime)) {
                self._addSegmentShape(segment);
            }
        });
        self.updateSegments(frameStartTime, frameEndTime);
    };
    SegmentsLayer.prototype._onSegmentsRemove = function (segments) {
        var self = this;
        segments.forEach(function (segment) {
            self._removeSegment(segment);
        });
        self._layer.draw();
    };
    SegmentsLayer.prototype._onSegmentsRemoveAll = function () {
        this._layer.removeChildren();
        this._segmentShapes = {};
        this._layer.draw();
    };
    SegmentsLayer.prototype._onSegmentsDragged = function (segment) {
        this._updateSegment(segment);
        this._layer.draw();
    };
    SegmentsLayer.prototype._createSegmentShape = function (segment) {
        return new SegmentShape(segment, this._peaks, this, this._view);
    };
    SegmentsLayer.prototype._addSegmentShape = function (segment) {
        var segmentShape = this._createSegmentShape(segment);
        segmentShape.addToLayer(this._layer);
        this._segmentShapes[segment.id] = segmentShape;
        return segmentShape;
    };
    SegmentsLayer.prototype.updateSegments = function (startTime, endTime) {
        var segments = this._peaks.segments.find(startTime, endTime);
        var count = segments.length;
        segments.forEach(this._updateSegment.bind(this));
        count += this._removeInvisibleSegments(startTime, endTime);
        if (count > 0) {
            this._layer.draw();
        }
    };
    SegmentsLayer.prototype._updateSegment = function (segment) {
        var segmentShape = this._findOrAddSegmentShape(segment);
        segmentShape.updatePosition();
    };
    SegmentsLayer.prototype._findOrAddSegmentShape = function (segment) {
        var segmentShape = this._segmentShapes[segment.id];
        if (!segmentShape) {
            segmentShape = this._addSegmentShape(segment);
        }
        return segmentShape;
    };
    SegmentsLayer.prototype._removeInvisibleSegments = function (startTime, endTime) {
        var count = 0;
        for (var segmentId in this._segmentShapes) {
            if (Utils.objectHasProperty(this._segmentShapes, segmentId)) {
                var segment = this._segmentShapes[segmentId].getSegment();
                if (!segment.isVisible(startTime, endTime)) {
                    this._removeSegment(segment);
                    count++;
                }
            }
        }
        return count;
    };
    SegmentsLayer.prototype._removeSegment = function (segment) {
        var segmentShape = this._segmentShapes[segment.id];
        if (segmentShape) {
            segmentShape.destroy();
            delete this._segmentShapes[segment.id];
        }
    };
    SegmentsLayer.prototype.setVisible = function (visible) {
        this._layer.setVisible(visible);
    };
    SegmentsLayer.prototype.draw = function () {
        this._layer.draw();
    };
    SegmentsLayer.prototype.destroy = function () {
        this._peaks.off('segments.update', this._onSegmentsUpdate);
        this._peaks.off('segments.add', this._onSegmentsAdd);
        this._peaks.off('segments.remove', this._onSegmentsRemove);
        this._peaks.off('segments.remove_all', this._onSegmentsRemoveAll);
        this._peaks.off('segments.dragged', this._onSegmentsDragged);
    };
    SegmentsLayer.prototype.fitToView = function () {
        for (var segmentId in this._segmentShapes) {
            if (Utils.objectHasProperty(this._segmentShapes, segmentId)) {
                var segmentShape = this._segmentShapes[segmentId];
                segmentShape.fitToView();
            }
        }
    };
    SegmentsLayer.prototype.draw = function () {
        this._layer.draw();
    };
    SegmentsLayer.prototype.getHeight = function () {
        return this._layer.getHeight();
    };
    return SegmentsLayer;
}(require('./segment-shape'), require('./utils'), require('konva'));